import { createTheme } from '@mui/material/styles';

// https://material-ui.com/customization/default-theme/

const theme = createTheme({
    palette: {
      primary: {        
        main: '#3f51b5',        
      },      
    },
  });

const themeConstants = {
    drawerWidth: 250
}

export default theme;
export { themeConstants };
